import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  UsersRemovedDataTotal,
  UserRemovedDataTotal,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { UsersRemovedTotalConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "users-removed-chart-total",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class UsersRemovedTotalChartComponent
  extends BaseChartLogic<UsersRemovedTotalConfig, UsersRemovedDataTotal>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      UsersRemovedTotalConfig,
      _ngZone
    );
    this.handleDataSubscription(
      this.analyticsService.usersRemovedDataTotalChange
    );
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: UsersRemovedDataTotal): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
  }

  refreshData(): void {
    this.analyticsService.getRemovedUsersDataTotal(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
